import React, { useEffect, useState, useCallback } from 'react';
import { Button, Grid, Form, Dimmer, Loader } from 'semantic-ui-react';
import { useDistributorSettings } from '../../providers/DistributorSettingsProvider';
import { useDistributors } from '../../providers/DistributorProvider';
import { useAuth } from '../../providers/AuthenticationProvider';

export const Settings = () => {
    const { checkStripeConnectAccount, manageStripeConnectAccount } = useDistributorSettings();
    const { uploadLogo } = useDistributors();
    const { distributor, setDistributor } = useAuth();
    const [loading, setLoading] = useState(false);
    const [stripeAccountExists, setStripeAccountExists] = useState(false);
    const [stripeChargesEnabled, setStripeChargesEnabled] = useState(false);
    const [stripeConnectAccountMessage, setStripeConnectAccountMessage] = useState('');
    const [stripeConnectAccountButtonText, setStripeConnectAccountButtonText] = useState('');

    useEffect(() => {
        const run = async () => {
            setLoading(true);
            const result = await checkStripeConnectAccount(distributor.id);
            setStripeAccountExists(result.accountExists);
            setStripeChargesEnabled(result.chargesEnabled);
            setLoading(false);
        };

        if (distributor?.id) {
            run();
        }
    }, [distributor, checkStripeConnectAccount]);

    useEffect(() => {
        if (!stripeAccountExists && !stripeChargesEnabled) {
            setStripeConnectAccountMessage('Click the button below to start creating a Stripe Connect account.');
            setStripeConnectAccountButtonText('Create Stripe Connect Account');
        } else if (stripeAccountExists && !stripeChargesEnabled) {
            setStripeConnectAccountMessage('Stripe is requesting some additional information; Click the button below to finish creating your Stripe Connect account.');
            setStripeConnectAccountButtonText('Update Stripe Connect Account');
        } else if (stripeAccountExists && stripeChargesEnabled) {
            setStripeConnectAccountMessage('Stripe does not need any additional information, your Stripe Connect account is able to accept transfers.');
            setStripeConnectAccountButtonText('Update Stripe Connect Account');
        }
    }, [stripeAccountExists, stripeChargesEnabled]);

    const changeLogo = useCallback(async (file) => {
        const { logoUrl } = await uploadLogo(distributor.id, file.name, file)

        let updatedDistributor = { ...distributor }
        updatedDistributor.logoUrl = logoUrl;

        setDistributor(updatedDistributor);
    }, [uploadLogo, setDistributor, distributor]);

    const handleManageStripeConnectAccount = useCallback(async () => {
        const result = await manageStripeConnectAccount(distributor.id);
        window.location.replace(result.accountLink);
    }, [manageStripeConnectAccount, distributor]);

    return (
        <>
            <Dimmer active={loading}>
                <Loader size='massive' active={loading}></Loader>
            </Dimmer>
            <div className="settings-container" style={{ marginTop: 16 }}>
                <Grid centered>
                    <Grid.Row>
                        <h1>Stripe Connect Account</h1>
                    </Grid.Row>
                    <Grid.Row>
                        <p>{stripeConnectAccountMessage}</p>
                    </Grid.Row>
                    <Grid.Row>
                        <Button
                            onClick={handleManageStripeConnectAccount}
                            disabled={stripeChargesEnabled}
                        >
                            {stripeConnectAccountButtonText}
                        </Button>
                    </Grid.Row>
                    <Grid.Row>
                        <h1>Change Logo</h1>
                    </Grid.Row>
                    <Grid.Row>
                        <Form.Input
                            type="file"
                            accept="image/*"
                            // loading={loading}
                            onChange={e => {
                                if (loading) {
                                    return;
                                }
                                if (e.target.files.length > 0) {
                                    changeLogo(e.target.files[0]);
                                }
                            }}
                        />
                    </Grid.Row>
                </Grid>
            </div>
        </>
    );
};
